export default "__VITE_ASSET__bf70e0e7__"